module.exports = "bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvZm9udHMvU291cmNlU2VyaWZQcm8tUmVndWxhci44OTk2OTMwLm90ZiI7"


//////////////////
// WEBPACK FOOTER
// ./node_modules/base64-loader!./node_modules/scratch-render-fonts/src/SourceSerifPro-Regular.otf
// module id = iAz1
// module chunks = 0